// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  envName: 'demo',
  production: true,
  symfonyEndpointNotSecured: "https://demo.uclics.fr/symfony/web", //http://127.0.0.1:8000
  symfonyEndpointSecuredForUser: "https://demo.uclics.fr/symfony/web", //http://127.0.0.1:8000/player/api
  symfonyEndpointSecuredForCompany: "https://demo.uclics.fr/symfony/web", //http://127.0.0.1:8000/company/api
  apiGetGame: "/game/",
  apiGetScore: "/getScore",
  apiRecordPlayAndUpdateStats: "/recordPlayAndUpdateStats/",
  apiInitGameStats: "/initGameStats/",
  apiGetNotifications: "/notifications/",
  apiAddNotification: "/notification/add",
  apiSetNotificationIsRead: "/notification/setNotificationIsRead",
  apiLogin: "/user/login",
  apiRegister: "/user/register",
  apiResetPwdRequest: "/user/resetting/resetpasswordrequest",
  apiResetPwd: "/user/resetting/resetpassword",
  apiGetUserByUsername: "/user/users/",
  apiEditUser:  "/user/edit",
  algoliaAppId: 'TNTWAMQJZS',
  algoliaApiKey: '2dea4ca02138b3cbd0aa4d668fa53505',
  algoliaIndexName: 'Game_dev',
  algoliaIndexSortByNameAsc : 'Game_dev_name_asc',
  algoliaUrlSync: false,
  maxNbClicPerHour: 100,
  maxNbClicPerHourAfterLike: 20,
  apiRegisterCpy: "/company/register",
  apiGetCompanyByUsername: "/get/",
  apiEditCompany: "/edit",
  apiAddGame: "/game/add/",
  apiGetDeliveryTypes: "/data/deliverytype/all",
  apiGetPrizeTypes: "/data/prizetype/all",
  apiGetGameCategories: "/data/gamecategory/all",
  apiRefreshToken: "/token/refresh",
  apiGetGamesByCompany : "/games/",
  MapsApiKey: "AIzaSyDZhpM6s0VIXbjOZJ27JJfkc3EWnbD35GY",
  apiGetStatsByGame: "/getStatsByGame/"
};



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/environments/environment.ts